// extracted by mini-css-extract-plugin
export default {"navItem":"abtasty-qa-assistant__Navigation-module__navItem___GKaHd"};